(() => {
  'use strict';
  document.documentElement.classList.add('js');

  const safeScroll = (target) => {
    if (!target) return;
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;
    const id = decodeURIComponent(link.getAttribute('href').slice(1));
    if (!id) return;
    const target = document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    safeScroll(target);
    history.replaceState(null, '', `#${encodeURIComponent(id)}`);
  });

  // Keep the currently selected kit visible in horizontal mobile selectors.
  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-variant-input]');
    if (!input) return;
    const card = input.closest('.ma-kit-card, [data-variant-card]');
    card?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });
})();
